import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appFocus]'
})
export class FocusDirective implements AfterViewInit, OnDestroy {

  @Input() public autoFocus: boolean;
  private timeoutId: any;

  constructor(private elementRef: ElementRef
  ) { }

  ngAfterViewInit(): void {
    this.timeoutId = setTimeout(() => {
      this.elementRef.nativeElement.focus();
    }, 500);
  }

  ngOnDestroy(): void {
    clearTimeout(this.timeoutId);
  }
}


